import React, { useState } from "react";
import { Box, IconButton, TextField, Tooltip } from "@mui/material";
import "./mapData.scss";
import AddIcon from "@mui/icons-material/Add";
export default function MapInput(props) {
  const { addMappingRowCallback } = props;
  const [count, setCount] = useState("");

  const onHandleCheckbox = () => {
    addMappingRowCallback(count);
    setCount("");
  };

  const onChangeInput = (value) => {
    const trimmedValue = value.replace(/^0+/, "");

    if (/^-?\d*$/.test(trimmedValue) && trimmedValue.length <= 3) {
      setCount(trimmedValue);
    }
  };
  return (
    <Box className="AddRow-wrap">
      {/* <h6>{label}</h6> */}
      <Box className="addRow-inputField">
        <Tooltip title="Add columns with a maximum of 3 digits." arrow>
          <TextField
            size="small"
            className="add-coloumnsInput"
            id="outlined-adornment-weight"
            value={count}
            placeholder="Add"
            onChange={(e) => onChangeInput(e.target.value)}
            aria-describedby="outlined-weight-helper-text"
          />
        </Tooltip>
        <IconButton
          size="small"
          className="rightClick-icon"
          onClick={(e) => onHandleCheckbox()}
        >
          <AddIcon size="small" />
        </IconButton>
      </Box>
    </Box>
  );
}
